/* @flow */
import AdminUpgradePaymentForm from './AdminUpgradePaymentForm';

export default AdminUpgradePaymentForm;
